import {ClientClientsState} from "../store/client_clients_state";
import {Reducer} from "redux";
import {
    ClientClientsAction,
    ClientClientsActionType,
    ICallbackCreateClientAction,
    ICallbackDeleteClientAction,
    ICallbackGetAllClientsAction,
    ICallbackUpdateRoleClientAction,
} from "../action/client_clients_action";

const initialState: ClientClientsState = {
    isLoading: false,
    clients: []
};

const clientClientsReducer: Reducer<ClientClientsState> = (state = initialState, action: ClientClientsAction): ClientClientsState => {
    switch (action.type) {

        case ClientClientsActionType.REQUEST_GET_ALL_CLIENTS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientClientsActionType.CALLBACK_GET_ALL_CLIENTS: {
            const _action = action as ICallbackGetAllClientsAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                    clients: _action.item ? _action.item.clients : [],
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientClientsActionType.REQUEST_CREATE_CLIENT: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientClientsActionType.CALLBACK_CREATE_CLIENT: {
            const _action = action as ICallbackCreateClientAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                    clients: _action.item ? _action.item.clients : [],
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientClientsActionType.REQUEST_UPDATE_ROLE_CLIENT: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientClientsActionType.CALLBACK_UPDATE_ROLE_CLIENT: {
            const _action = action as ICallbackUpdateRoleClientAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                    clients: _action.item ? _action.item.clients : [],
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientClientsActionType.REQUEST_DELETE_CLIENT: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientClientsActionType.CALLBACK_DELETE_CLIENT: {
            const _action = action as ICallbackDeleteClientAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                    clients: _action.item ? _action.item.clients : [],
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientClientsReducer;


// WEBPACK FOOTER //
// ./src/presentation/reducer/client_clients_reducer.ts